import { Mapper } from "../../../../base/utils/mapper";
import { DepartamentModel } from "../../../../domain/models/configuration/departament.model";
import { DepartamentEntity } from "../entities/departament.entity";


export class DepartamentImplementationRepositoryMapper extends Mapper<DepartamentEntity, DepartamentModel> {
    mapFrom(param: DepartamentEntity): DepartamentModel {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        };
    }
    mapTo(param: DepartamentModel): DepartamentEntity {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        }
    }
}